import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES } from "../data/content";
import ScrollToTop from "./general/ScrollToTop";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import About from "./about/About";
import RoomPage from "./rooms/RoomPage";
import Gallery from "./gallery/Gallery";
import Showroom from "./showroom/Showroom";
import Contact from "./contact/Contact";
import NotFound from "./general/NotFound";

//The four room pages share one layout - the key is the ROOM_PAGES entry in content.js
const ROOM_ROUTES = [
  [ROUTES.KITCHENS, "KITCHENS"],
  [ROUTES.BEDROOMS, "BEDROOMS"],
  [ROUTES.BATHROOMS, "BATHROOMS"],
  [ROUTES.ENTERTAINMENT, "ENTERTAINMENT"],
];

const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
      >
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={<Home />}
          />
          <Route
            path={ROUTES.ABOUT}
            element={<About />}
          />
          {ROOM_ROUTES.map(([path, room]) => (
            <Route
              key={room}
              path={path}
              element={(
                <RoomPage
                  key={room}
                  room={room}
                />
              )}
            />
          ))}
          <Route
            path={ROUTES.GALLERY}
            element={<Gallery />}
          />
          <Route
            path={ROUTES.SHOWROOM}
            element={<Showroom />}
          />
          <Route
            path={ROUTES.CONTACT}
            element={<Contact />}
          />
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default App;
